import React from 'react';
import { Helmet } from '@okapi/helmet-react';

export const MetaFavicon = () => (
	<Helmet>
		<link
			rel="shortcut icon"
			type="image/x-icon"
			href="https://cdn.lemanapro.ru/lmru/image/upload/other/favicon/favicon.ico?r=2162094"
		/>
	</Helmet>
);
